import PropTypes from 'prop-types';
import React from 'react';
import { writeFile, utils } from 'sheetjs-style';

import CustomButton from 'src/common/components/CustomButton';

const CreateExcel = ({
	data = [],
	columns = [],
	fileName = '',
	label = 'Descargar Excel',
	className = '',
	disabled = false,
}) => {
	const exportExcel = () => {
		if (data.length !== 0 && columns.length !== 0) {
			const formattedData = data.map((item) => {
				const row = {};
				columns.forEach((col) => {
					row[col.text] = item[col.dataField];
				});
				return row;
			});

			const worksheet = utils.json_to_sheet([], { origin: 'A1' });

			const headerTexts = columns.map((col) => col.text);
			utils.sheet_add_aoa(worksheet, [headerTexts], { origin: 'A1' });

			utils.sheet_add_json(worksheet, formattedData, {
				origin: 'A2',
				skipHeader: true,
			});

			headerTexts.forEach((text, index) => {
				const colLetter = String.fromCharCode(65 + index);
				const cellAddress = colLetter + '1';

				if (!worksheet[cellAddress]) {
					worksheet[cellAddress] = { t: 's', v: text };
				}

				worksheet[cellAddress].s = {
					fill: { fgColor: { rgb: 'DCE6F1' } },
					font: { bold: true },
					alignment: { horizontal: 'center' },
				};
			});

			worksheet['!cols'] = columns.map((col, index) => {
				const headerLength = col?.text ? col.text.length : 0;

				const maxLength = Math.max(
					headerLength,
					...formattedData.map((row) => {
						const value = row[col.text];
						return value ? value.toString().length : 0;
					})
				);

				return { wch: maxLength + 2 };
			});

			const workbook = {
				Sheets: { Datos: worksheet },
				SheetNames: ['Datos'],
			};

			writeFile(workbook, fileName);
		}
	};

	return (
		<CustomButton
			className={className}
			disabled={disabled}
			color="info"
			onClick={exportExcel}
			mainText={label}
		/>
	);
};

CreateExcel.propTypes = {
	columns: PropTypes.array.isRequired,
	data: PropTypes.array.isRequired,
	fileName: PropTypes.string.isRequired,
	label: PropTypes.string,
	className: PropTypes.string,
	disabled: PropTypes.bool,
};

export default CreateExcel;
